import { homeConstants } from "../constants";

export default function (
  state = {
    isProgress: false,
    data: {},
  },
  action
) {
  switch (action.type) {
    case homeConstants.SEND_TEXT_MESSAGE_REQUEST:
      return {
        ...state,
        data: {},
        isProgress: true,
      };
    case homeConstants.SEND_TEXT_MESSAGE_SUCCESS: {
      return {
        ...state,
        data: action.response,
        isProgress: false,
      };
    }
    case homeConstants.SEND_TEXT_MESSAGE_FAILURE:
      return {
        ...state,
        data: {},
        isProgress: false,
      };
    case homeConstants.RESET_SEND_TEXT_MESSAGE_INFO:
      return {
        ...state,
        data: {},
        isProgress: false,
      };
    default:
      return state;
  }
}
